module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ik00DH/tc-custom/9781440526558.jpg?1730542028376",
      "alt": "This image is the cover for the book Uncommon Courtesy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Uncommon Courtesy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This book is the short slap to the back of the head most people need nowadays. In a world that's more likely to flip the bird than hold the door, it's their reminder of proper behavior. You'll receive a (re-)schooling in manners with lessons split up by situation, then tackled by topic. Each note corrects conduct that's become all too common, like . . ."), _c('br'), _c('br'), _c('b', [_vm._v("Bad Behavior")]), _vm._v(": Popping a piece of gum into your mouth midconversation, and stressing your point by snapping it."), _c('br'), _c('br'), _c('b', [_vm._v("Courteous Fix")]), _vm._v(": If you're going to have a piece of gum while talking to someone, be sure to offer your companion a piece--and keep your mouth closed as you chew. You want your breath to be fresh. Not your attitude."), _c('br'), _c('br'), _vm._v("It's a reminder that it wasn't always out of place to be polite.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer M. Wood\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0